// src/components/ServicesDrawer.js
import React from "react";
import { FaTimes } from "react-icons/fa";

const ServicesDrawer = ({ isOpen, onClose }) => {
  const servicesList = [
    { id: 1, name: "Corporate Events" },
    { id: 2, name: "Airport Rides" },
    { id: 3, name: "Local Rides" },
    { id: 4, name: "Luxury Rides" },
    { id: 5, name: "Long Distance" },
    { id: 6, name: "Weddings" },
    { id: 7, name: "Proms" },
    { id: 8, name: "City Tours" },
    { id: 9, name: "Wine Tours" },
    { id: 10, name: "Cruise Port Transfers" },
    { id: 11, name: "Business Meetings" },
    { id: 12, name: "VIP Transportation" },
    { id: 13, name: "Night Outs" },
    { id: 14, name: "Casino Trips" },
    { id: 15, name: "Quinceañeras" },
    { id: 16, name: "Anniversaries" },
    { id: 17, name: "Birthday Parties" },
    { id: 18, name: "Road Shows" },
    { id: 19, name: "Sporting Events" },
    { id: 20, name: "Executive Services" },
  ];

  const phoneNumber = "9142762961";

  return (
    <div className={`services-drawer ${isOpen ? "open" : ""}`}>
      <div className="drawer-header">
        <h2>Our Services</h2>
        <button className="drawer-close-btn" onClick={onClose}>
          <FaTimes />
        </button>
      </div>
      <hr className="drawer-divider" />
      <div className="drawer-content">
        <p>Select and connect with Heritage Car Airports immediately</p>
        <ul>
          {servicesList.map((service) => (
            <li key={service.id}>
              <a className="service-item" href={`tel:${phoneNumber}`}>
                {service.name}
              </a>
            </li>
          ))}
        </ul>
      </div>
      {/* Estilos en línea para este componente */}
      <style>{`
        .services-drawer {
          position: fixed;
          top: 0;
          left: 0;
          width: 180px;
          height: 100%;
          background: rgba(255, 255, 255, 0.95);
          border-right: 1px solid #2B3F50;
          box-shadow: 2px 0 8px rgba(0,0,0,0.3);
          transform: translateX(-100%);
          transition: transform 0.3s ease;
          z-index: 101;
          display: flex;
          flex-direction: column;
          backdrop-filter: brightness(1.05);
        }
        .services-drawer.open {
          transform: translateX(0);
        }
        .drawer-header {
          background: rgba(248,248,248,0.95);
          border-bottom: 1px solid #ddd;
          padding: 16px;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        .drawer-divider {
          border: 0;
          height: 1px;
          background: #2B3F50;
          margin: 0;
        }
        .drawer-content {
          padding: 16px;
          overflow-y: auto;
          flex: 1;
        }
        .drawer-content p {
          margin-top: 0;
          font-weight: bold;
        }
        .drawer-content ul {
          list-style: none;
          padding: 0;
          margin: 0;
        }
        .drawer-content li {
          margin-bottom: 10px;
        }
        .service-item {
          width: 100%;
          background: #9AA6B2;
          color: #0d2b3e;
          padding: 8px;
          border-radius: 4px;
          text-decoration: none;
          display: block;
          transition: background-color 0.2s ease;
        }
        .service-item:hover {
          background: #7a8b98;
        }
      `}</style>
    </div>
  );
};

export default ServicesDrawer;
